// extracted by mini-css-extract-plugin
export var container = "_cq-0";
export var icon = "_cq-1";
export var text = "_cq-2";